import { type PropsWithChildren } from 'react';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
    color: ${({ theme }) => theme.colors.text.main.enabled};
  }
`;

export const GlobalStylesProvider = ({ children }: PropsWithChildren) => {
	return (
		<>
			<GlobalStyle />
			{children}
		</>
	);
};
